// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"18357": "70fb16f8c80d","22898": "c617a8eb882e","42530": "81999d02ec3f","53911": "3cd5c82348a5","65336": "ea808a117b2e","66863": "c939bdd77392","99872": "9d1a45acbd39",}[chunkId] + ".css"
}